import React from 'react';

/** Lazy ClientComputedVideo (not wrapped in a suspense to use the parent widget loading fallback) */
export const ClientComputedVideo = React.lazy(
    () =>
        import(
            /* webpackChunkName: 'widget-video' */
            './ClientComputedVideo'
        ),
);
